import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/playPlan',
  title: window.language['menu.program.playPlan'],
  component: dynamicWrapper(app, 
    [
      import('../../System/Org/model'), 
      import('../../System/SysConfig/model'),
      import('../../HomePage/model'),
      import('../../Material/Material/model'), 
      import('../../Material/Folder/model'), 
      import('../Playlist/model'),
      import('./model')
    ], 
    () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Program/PlayPlan/index.js